// Vendor library bundle entry point
import Swiper from 'swiper/bundle';

// Make Swiper globally available
window.Swiper = Swiper;

// Note: jcf, slick, and viewportchecker files are loaded separately
// as they rely on global jQuery and don't work well with bundlers
